// extracted by mini-css-extract-plugin
export default {"container":"MenuList_container_fF8FK"};